import type { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useStytchSession } from '@stytch/nextjs';

import LoadingScreen from 'components/container-components/LoadingScreen';
import withLayout from 'components/container-components/layout/withLayout';
import { AuthRoutes, CommonRoutes } from 'routes';
import { useUser } from 'context/user';

const Home: NextPage = () => {
  const router = useRouter();
  const { mutate: mutateUser } = useUser();
  const { session, isInitialized, fromCache } = useStytchSession();

  useEffect(() => {
    // if logged in, redirect to dashboard
    if (fromCache) {
      mutateUser();
      return;
    }

    if (!isInitialized) {
      return;
    }

    // replace, not push: an effect-driven redirect must not stay in history, or the
    // back button lands here and the same condition bounces the user forward again.
    if (session && isInitialized) {
      router.replace(CommonRoutes.Dashboard);
    } else {
      router.replace(AuthRoutes.SignIn);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session, isInitialized, fromCache]);

  return (
    <main className="h-screen">
      <LoadingScreen />
    </main>
  );
};

export default withLayout(Home);
